import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
    return (
        <header data-bs-theme="dark">
        <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
            <div className="container-fluid">
            <Link className="navbar-brand" to="/">The First Spring Studio</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                <li className="nav-item">
                    <Link className="nav-link" to="/" aria-current="page">Home</Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/gallery">Gallery</Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/events">Events</Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/paintingStore">Store</Link> 
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/contact">Contact Us</Link>
                </li>
                </ul>
                {/* Right-aligned items */}
                <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <Link className="nav-link" to="/login">Login</Link>
                </li>
                </ul>
            </div>
            </div>
        </nav>
        </header>
    );
}

export default Navbar;
